import { CircularProgress, Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import ProductivityChart from "./components/ProductivityChart";
import styled from "styled-components";
import { useAuthContext } from "../../../authentication/Auth";
import app from "../../../authentication/firebaseStart";
import DropdownCustom from "../../../components/DropdownCustom";
import { useTranslation } from "react-i18next";
import instance from "../../../axios/axios";
import config from "../../../data/application.properties";
import { PRODUCTIVITY_CONSTANT } from "../../../data/constants";
import { userJustManager } from "../../../data/userUtil";
import LicenseCardComponent from "./components/LicenseCardComponent";
import ContactCardContainer from "./components/ContactCardComponent";
import VersionCardComponent from "./components/VersionCardComponent";

const Heading = styled.div`
  font-size: 24px;
  font-weight: 500;
  padding-bottom: 10px;
`;

const PageWrapper = styled.div`
  ${"" /* //background-color: #F3F6FA; */}
`;

const SiteData = styled.div`
  display: flex;
  flex-direction: column;
  color: black;
`;

const SiteNameLabel = styled.div`
  font-size: 16px;
  font-weight: 500;
`;

const StyledTextField = styled.div`
  font-size: 16px;
`;

const WelcomeMessage = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  color: #000000;
`;

const firestore = app.firestore();

const lostLabeling = PRODUCTIVITY_CONSTANT.lostLabeling;
const foundLabeling = PRODUCTIVITY_CONSTANT.foundLabeling;
const totalLost = PRODUCTIVITY_CONSTANT.totalLost;
const totalFound = PRODUCTIVITY_CONSTANT.totalFound;
const timeTakenToLost = PRODUCTIVITY_CONSTANT.timeTakenToLost;
const timeSpendToFind = PRODUCTIVITY_CONSTANT.timeSpendToFind;

const options = [
  { label: "Weekly", value: "Weekly" },
  { label: "Monthly", value: "Monthly" },
];

export default function ProductivityPage({ isDGAMLicensed }) {
  const [siteDatas, setsiteData] = useState([]);
  const context = useAuthContext();
  const { t } = useTranslation();
  const isManager = userJustManager(context.currentUser.claims);
  const companyID = context.currentUser.claims.companyID;
  const isSSOLoggedIn = localStorage.getItem('ssoLogin') === 'true'
  const emailId = isSSOLoggedIn ? context.currentUser.uid : context.currentUser.email;
  const [isLoading, setIsLoading] = useState(false);
  const siteContext = isManager ? context.currentUser.claims.siteArr[0] : null;
  const DEFAULT_SITE = {
    label: !siteContext ? "All Sites" : siteContext,
    value: !siteContext ? "" : siteContext,
  };
  const [initSiteData, setInitSiteData] = useState([DEFAULT_SITE]);
  const [SITE_FILTER, set_SITE_FILTER] = useState(DEFAULT_SITE);
  const chartData = [];
  const [selectedPeriod, setSelectedPeriod] = useState({
    label: "Weekly",
    value: "Weekly",
  });
  const [productivityData, setProductivityData] = useState([]);
  const [lastUpdatedDate, setLastUpdatedDate] = useState("");

  /**
   * *This section handles the user site selection
   * @function getInitialSitesData for fetching initial site data
   * @function getSelectInputSearch handles the user site search
   * @function changeOnFilter handles site selection in session as well
   */

  useEffect(() => {
    getInitialSitesData();
  }, [SITE_FILTER]);

  useEffect(() => {
      //getInitialSitesData()
      const selectedSite = sessionStorage.getItem("selectedSite");
      if (selectedSite != null) {
        if (
          selectedSite === "All Devices" ||
          selectedSite === "Unassigned Devices" ||
          selectedSite === "ALL SITES"
        ) {
          set_SITE_FILTER(DEFAULT_SITE);
        } else {
          set_SITE_FILTER({ label: selectedSite, value: selectedSite });
        }
      } 
      else {
        set_SITE_FILTER(DEFAULT_SITE);
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let getInitialSitesData = async () => {
    try {
      if (isManager) {
        let sitesArr = []
        context.currentUser.claims.siteArr.forEach(el=>{
          sitesArr.push({label: el, value: el})
        })
        setInitSiteData(sitesArr);
        setsiteData(sitesArr);
      }
      else{
        let siteData = (
          await firestore
            .collection("tenants")
            .doc(companyID)
            .collection("SiteLocations")
            .orderBy("displaySiteName")
            .limit(10)
            .get()
        ).docs.map((doc) => doc.data());

        let fSiteData = [DEFAULT_SITE];

        siteData.forEach((element) => {
          fSiteData.push({ label: element.siteName, value: element.siteName });
        });
        setInitSiteData(fSiteData);
        setsiteData(fSiteData);
      }
    } catch (err) {
      onError(err);
    }
  };

  let getSelectInputSearch = async (rawInput, type) => {
    try {
      if (type === "ENTERHIT" && rawInput) {
        let sites = [];
        setIsLoading(true);

        sites = (
          await firestore
            .collection("tenants")
            .doc(companyID)
            .collection("SiteLocations")
            .orderBy("siteName")
            .startAt(rawInput.toUpperCase())
            .endAt(rawInput.toUpperCase() + "\uf8ff")
            .limit(10)
            .get()
        ).docs.map((doc) => doc.data());

        let finalSitesArray = [DEFAULT_SITE];
        if (sites.length > 0) {
          sites.forEach((element) => {
            finalSitesArray.push({
              label: element.siteName,
              value: element.siteName,
            });
          });
        }
        setsiteData(finalSitesArray);
        setIsLoading(false);
      }
    } catch (err) {
      onError(err);
    }
  };

  const onError = (err) => {
    console.log(err);
    setIsLoading(false);
  };

  let changeOnFilter = (data, filter) => {
    try {
      if (filter == "site") {
        let selectedSite = data?.target.value;
        if (selectedSite === "All Sites" || selectedSite === "") {
          selectedSite = "All Devices";
        }
        sessionStorage.setItem("selectedSite", selectedSite);
        if (data?.target.value !== SITE_FILTER.value)
          set_SITE_FILTER(data?.target);
      }
    } catch (err) {
      onError(err);
    }
  };

  useEffect(() => {
    getProductivityData(SITE_FILTER, selectedPeriod);
  }, [SITE_FILTER, selectedPeriod]);

  /**
   * * Fetches the productivity data
   * * Formatting data acc to recharts lineChart
   * @param {{value :"",label:""}} selectedSite
   * @param {{value :"",label:""}} selectedPeriod
   */

  let getProductivityData = async (selectedSite, selectedPeriod) => {
    try {
      setIsLoading(true);
      let timePeriod = selectedPeriod.value === "Weekly" ? 7 : 30;
      const productivityData = await instance.post(
        config.GET_PRODUCTIVITY_DATA,
        {
          site: selectedSite.value,
          timePeriod: timePeriod,
        }
      );
      const data = productivityData.data.data;
      const companysData = data.company;
      const siteData = data.site;
      let siteDataJson = {};
      for (let i = 0; i < siteData.length; i++) {
        siteDataJson[siteData[i].timePeriod] = siteData[i];
      }
      if (data.lastUpdatedOn) {
        setLastUpdatedDate(data.lastUpdatedOn);
      }

      companysData.map((companyData) => {
        let data = {};
        data.name = companyData.timePeriod;
        data[`company${lostLabeling}`] = companyData[lostLabeling];
        data[`company${foundLabeling}`] = companyData[foundLabeling];
        data[`company${timeTakenToLost}`] = companyData[timeTakenToLost];
        data[`company${timeSpendToFind}`] = companyData[timeSpendToFind];
        if (siteData.length > 0) {
          if (siteDataJson[companyData.timePeriod]) {
            data[`site${totalLost}`] =
              siteDataJson[companyData.timePeriod][totalLost];
            data[`site${totalFound}`] =
              siteDataJson[companyData.timePeriod][totalFound];
            data[`site${timeTakenToLost}`] =
              siteDataJson[companyData.timePeriod][timeTakenToLost];
            data[`site${timeSpendToFind}`] =
              siteDataJson[companyData.timePeriod][timeSpendToFind];
          } else{
            data[`site${totalLost}`] = 0;
            data[`site${totalFound}`] = 0;
            data[`site${timeTakenToLost}`] = 0;
            data[`site${timeSpendToFind}`] = 0;
          }
        }
        chartData.push(data);
      });
      chartData.unshift({});
      chartData.push({});
      console.log(chartData)
      setIsLoading(false);
      setProductivityData(chartData);
    } catch (err) {
      console.log(err);
    }
  };

  let changeOnFilterForPeriod = (event) => {
    let selectedValue = event?.target.value;
    if (selectedValue !== selectedPeriod.value)
      setSelectedPeriod({ label: selectedValue, value: selectedValue });
  };

  const cardWrapperStyle = {
    height: '100%', 
    padding: '16px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    backgroundColor: '#fff',
    borderRadius: '8px',
    overflow: 'auto', 
    marginTop: '16px',
  };

  return (
    <div style={cardWrapperStyle}>
      <PageWrapper
        style={{
          cursor: isLoading ? 'wait' : 'default',
          opacity: isLoading ? '0.4' : '1',
          position: 'relative',
        }}
      >
        {isLoading && (
          <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
            <CircularProgress />
          </div>
        )}
        {!isDGAMLicensed && (
          <>
            <div>
              {/* <Heading>{t("productivity.title")}</Heading> */}
              <WelcomeMessage>
                {emailId ? `Welcome ${emailId.split('@')[0]}`: 'Welcome'}
              </WelcomeMessage>
            </div>
            <div style={{ marginTop: '4px', fontSize: '16px', color: '#666' }}>
              Last Updated : {lastUpdatedDate}
            </div>
          </>
        )}
        <Grid container spacing={1} justifyContent="flex-end" alignItems="center">
          <Grid item xs="auto">
            <div
              style={{
                padding: '4px',
                marginBottom: '4px',
                maxWidth: '100%',
              }}
            >
              <span
                style={{ zIndex: 1, position: 'relative', marginLeft: '3px' }}
              >
              </span>
              <DropdownCustom
                data-testid="periodId"
                selectOpts={siteDatas}
                onChange={(e) => changeOnFilter(e, "site")}
                resetSelect={false}
                selectVal={SITE_FILTER.label ? SITE_FILTER : DEFAULT_SITE}
                isSearchable={true}
                onSearchInpChange={getSelectInputSearch}
                isLoading={isLoading}
                customFilterOption={() => {
                  return siteDatas;
                }}
                selectOnBlur={() => {}}
              />
            </div>
          </Grid>
          <Grid item xs="auto">
            <div
              style={{ padding: '4px', marginBottom: '4px', maxWidth: '100%' }}
            >
              <span
                style={{ zIndex: 1, position: 'relative', marginLeft: '3px' }}
              >
              </span>
              <DropdownCustom
                selectOpts={options}
                onChange={(e) => changeOnFilterForPeriod(e)}
                resetSelect={false}
                selectVal={selectedPeriod}
                isSearchable={false}
              />
            </div>
          </Grid>
        </Grid>
        
        <Grid container spacing={1}>
          <Grid item xs={12} md={3}>
            <ProductivityChart
              title={
                t("productivity.deviceMissingChartTItle") +
                ` (${SITE_FILTER.label === "All Sites" || SITE_FILTER.label === "" ? "N/A" : SITE_FILTER.label})`
              }
              data={productivityData}
              values={{
                line1DataKey: `company${lostLabeling}`,
                line2DataKey: `site${totalLost}`,
                yAxisLabel: t("productivity.nodYAxisLabel"),
                line1Plot:
                  t("productivity.average") +
                  " "+
                  t("productivity.deviceMissing"),
                line2Plot:
                  t("productivity.total") +
                  " "+
                  t("productivity.deviceMissing"),
                line1Color: "#0070C0", // Deep Blue
                line2Color: "#ADD8E6", // Light Blue
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <ProductivityChart
              title={
                t("productivity.deviceFoundChartTItle") +
                ` (${SITE_FILTER.label === "All Sites" || SITE_FILTER.label === "" ? "N/A" : SITE_FILTER.label})`
              }
              data={productivityData}
              values={{
                line1DataKey: `company${foundLabeling}`,
                line2DataKey: `site${totalFound}`,
                yAxisLabel: t("productivity.nodYAxisLabel"),
                line1Plot:
                  t("productivity.average") +
                  " "+
                  t("productivity.deviceFound"),
                line2Plot:
                  t("productivity.total") +
                  " "+
                  t("productivity.deviceFound"),
                line1Color: "#0070C0", // Deep Blue
                line2Color: "#ADD8E6", // Light Blue
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <ProductivityChart
              title={
                t("productivity.averageCompany") +
                ` (${SITE_FILTER.label === "All Sites" || SITE_FILTER.label === "" ? "N/A" : SITE_FILTER.label})`
              }
              data={productivityData}
              values={{
                line1DataKey: `company${timeSpendToFind}`,
                line2DataKey: `site${timeSpendToFind}`,
                yAxisLabel: t("productivity.avgYAxisLabel"),
                line1Plot: t("productivity.average") +
                " "+ t("productivity.timeMissing"),
                line2Plot: t("productivity.total") +
                " "+ t("productivity.timeMissing"),
                line1Color: "#f0071e", // Deep Red
                line2Color: "#03a60e", // Light green
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <ProductivityChart
              title={
                t("productivity.averageSite") +
                ` (${
                  SITE_FILTER.label === "All Sites" || SITE_FILTER.label === ""
                    ? "N/A"
                    : SITE_FILTER.label
                })`
              }
              data={productivityData}
              values={{
                line1DataKey: `company${timeTakenToLost}`,
                line2DataKey: `site${timeTakenToLost}`,
                yAxisLabel: t("productivity.avgYAxisLabel"),
                line1Plot: t("productivity.average") +
                " "+ t("productivity.timeToFind"),
                line2Plot: t("productivity.total") +
                " "+ t("productivity.timeToFind"),
                line1Color: "#f0071e", // Deep red
                line2Color: "#03a60e", // Light green
              }}
            />
          </Grid>
          <Grid item xs={12} md={4} style={{ display: 'flex' }}>
              <VersionCardComponent 
                title= {t("version.latestGuardianUpdates")}
                content={t("version.releaseNotes")}
                tooltipText = {t("version.tooltipText")}
              />
          </Grid>
          <Grid item xs={12} md={4} style={{ display: 'flex' }}>
            <LicenseCardComponent
              title={t("license.title")}
              tooltipText={t("license.tooltipText")}
              usedLabel={t("license.usedLabel")}
              unusedLabel={t("license.unusedLabel")}
              totalLabel={t("license.totalLabel")}
              dropdownOptions={[
                { label: t("license.dropdownOptions.deviceGuardian"), value: t("license.dropdownOptions.deviceGuardianValue") },
                { label: t("license.dropdownOptions.accessories"), value: t("license.dropdownOptions.accessoriesValue") }
              ]}
            />
          </Grid>
          <Grid item xs={12} md={4} style={{ display: 'flex' }}>
            <ContactCardContainer
              title= {t("contactCard.title")}
              content={t("contactCard.content")}
              contact = {t("contactCard.buttonText")}
            />
          </Grid>
        </Grid>
      </PageWrapper>
    </div>
  );
}